import React, { useEffect, useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@duck/ui'
import { Info } from 'lucide-react'
import { useTar } from '@/modules'
import { useAuth } from '@/hooks/useAuth'
import { useDebouncedEffect } from '@/hooks/useDebouncedEffect'

export const AcceptChallengeDialog: React.FC = () => {
  const { t } = useTar()
  const {
    isAcceptChallengeDialogOpen,
    closeAcceptChallengeDialog,
    invitationData,
    joinPublicAssignment,
    isJoiningAssignment,
  } = useAuth()
  const [isDebouncing, setIsDebouncing] = useState(false)

  const taskName = invitationData?.taskName
  const organizationName = invitationData?.organizationName

  useEffect(() => {
    if (isAcceptChallengeDialogOpen) {
      setIsDebouncing(true)
    } else {
      setIsDebouncing(false)
    }
  }, [isAcceptChallengeDialogOpen])

  useDebouncedEffect(
    () => {
      if (isAcceptChallengeDialogOpen) {
        joinPublicAssignment()
        setIsDebouncing(false)
      }
    },
    [isAcceptChallengeDialogOpen, joinPublicAssignment],
    2500
  )

  const handleCancel = () => {
    closeAcceptChallengeDialog()
  }

  const isLoading = isDebouncing || isJoiningAssignment

  return (
    <Dialog open={isAcceptChallengeDialogOpen} onOpenChange={(open) => !open && handleCancel()}>
      <DialogContent width="sm" noMinHeight>
        <DialogHeader>
          <DialogTitle>
            {t('challenges.acceptChallenge')}
          </DialogTitle>
          <DialogDescription>
          </DialogDescription>
        </DialogHeader>
        <div className="py-4 space-y-8 mb-4">
          <div className="flex items-start gap-3 rounded-lg border border-primary/20 bg-primary/5 p-4">
            <Info className="h-5 w-5 text-primary shrink-0 mt-0.5" />
            <p className="text-sm">
              {t('challenges.acceptChallengeDescription', {
                taskName: taskName || t('challenges.challenge'),
                organizationName: organizationName || t('common.organization'),
              })}
            </p>
          </div>
          {isLoading && (
            <div className="flex flex-col items-center gap-4 py-2">
              <div className="h-1.5 w-32 overflow-hidden rounded-full bg-secondary">
                <div className="h-full w-1/3 bg-primary rounded-full animate-progress-indeterminate" />
              </div>
              <p className="text-sm text-muted-foreground">
                {t('challenges.accepting')}
              </p>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}
